module.exports = __webpack_public_path__ + "img/power.1f545e0f.png";